import React from 'react';

const VideoCard = ({ video, isSelected, onClick }) => {
  // Remove "SYNTube: " from the title
  const cleanTitle = video.snippet.title.replace('SYNTube: ', '');
  
  // Format the date
  const publishedDate = new Date(video.contentDetails.videoPublishedAt).toLocaleDateString('en-US', {
    year: 'numeric'
  });

  return (
    <div
      onClick={onClick}
      className={`min-w-80 p-6 border border-gray-200 rounded-lg shadow cursor-pointer transition-colors duration-200 ${
        isSelected 
          ? 'bg-[#005152] text-white border-[#005152]' 
          : 'bg-white'
      }`}
    >
      <div className="flex justify-between items-start">
        <h5 className={`mb-1 text-xl font-bold tracking-tight truncate max-w-[70%] font-header ${
          isSelected ? 'text-white' : 'text-gray-900'
        }`}>
          {cleanTitle}
        </h5>
        <p className={`mb-2 font-normal text-right font-body text-sm ${
          isSelected ? 'text-white' : 'text-gray-700'
        }`}>
          {publishedDate}
        </p>
      </div>
    </div>
  );
};

export default VideoCard; 